/**
 * @Author: qinyifang
 * @Date: 2025-04-28 14:43:11
 * @Description: 应用入口文件，初始化Vue应用和全局配置
 */
import { createApp } from "vue"
import App from "./App.vue"
import { router } from "./router"
import store from "./store"
import ElementPlus from "element-plus"
import "element-plus/dist/index.css"

import "@/assets/css/reset.css"
import { loadDirectives } from "@/directives"

import "element-plus/es/components/loading/style/css"
import "element-plus/es/components/message-box/style/css"

if (import.meta.env.VITE_NODE_ENV === "development" || import.meta.env.VITE_NODE_ENV === "testing") {
  import("vconsole").then((VConsole) => {
    new VConsole.default()
  })
}

const app = createApp(App)
/** 加载自定义指令 */
loadDirectives(app)

app.use(store)
app.use(router)
app.use(ElementPlus)

// pinia-plugin-persist 会自动从 localStorage 恢复数据，无需手动处理
router.isReady().then(() => {
  app.mount("#app")
})
